let _config = null;

export function initSiteConfig(apiData, envData) {
  // envData = build-time env vars (fallback for local dev)
  // apiData = API response (takes priority in production)
  _config = { ...envData, ...apiData };
}

export function getSiteConfig(key, defaultValue) {
  if (key === "REACT_APP_NODEJS_API_BASE_URL") return process.env.REACT_APP_NODEJS_API_BASE_URL;
  if (key === "REACT_APP_NODEJS_API_KEY") return process.env.REACT_APP_NODEJS_API_KEY;
  // Backward-compat: treat legacy API base key as NodeJS API base during migration
  if (key === "REACT_APP_API_BASE_URL") {
    return process.env.REACT_APP_NODEJS_API_BASE_URL || process.env.REACT_APP_API_BASE_URL;
  }

  if (!_config) {
    console.warn("siteConfig not initialized yet, key:", key);
    return defaultValue;
  }
  return _config[key] !== undefined && _config[key] !== "" ? _config[key] : defaultValue;
}
